// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LocationInput {
  font-size: 14px;
  padding: 8px 12px;
}`, "",{"version":3,"sources":["webpack://./src/features/DriveTimeTool/components/LocationInput/styles.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,iBAAA;AACF","sourcesContent":[".LocationInput {\n  font-size: 14px;\n  padding: 8px 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
